import { ViewActions, ViewActionButton } from '@/formUi'

import { useChangePasswordModal } from '../../modals/ChangePasswordModal'
import { useTexts } from './useTexts'

type Props = {
  onEdit: () => void
}

export function GpsAccountViewActions(props: Props) {
  const { onEdit } = props

  const texts = useTexts()
  const { Modal: ChangePasswordModal, show: showChangePasswordModal } = useChangePasswordModal()

  return (
    <>
      <ViewActions>
        <ViewActionButton
          label={texts.edit}
          testId="settings-gps-account-edit-button"
          onClick={onEdit}
        />

        <ViewActionButton
          onClick={showChangePasswordModal}
          testId="settings-gps-account-change-password-button"
          label={texts.changePassword}
        />
      </ViewActions>

      {/* Inject the Modal's Root */}
      <ChangePasswordModal />
    </>
  )
}
